import React from "react";
import { brandAssets } from "../../data/commerce";
import type { CoverCropArea } from "../../types/landing";
interface CoverCropProps {
  crop: CoverCropArea;
  alt: string;
  className?: string;
  eager?: boolean;
}
/** Recorta una portada individual a partir del mockup general */
export function CoverCrop({
  crop,
  alt,
  className = "",
  eager = false
}: CoverCropProps) {
  const size = brandAssets.mockupSize;
  return <div className={`relative overflow-hidden bg-crema ${className}`} style={{
    aspectRatio: `${crop.w} / ${crop.h}`
  }} data-id="element-310" data-mp="12jweksewrzms">
      <img src={brandAssets.mockup} alt={alt} loading={eager ? "eager" : "lazy"} className="absolute" style={{
      width: `${size / crop.w * 100}%`,
      maxWidth: "none",
      left: `${-crop.x / crop.w * 100}%`,
      top: `${-crop.y / crop.h * 100}%`
    }} data-id="element-311" data-mp="xkbe2dk3bj7y" />
    </div>;
}